module.exports = __webpack_public_path__ + "img/loading3.3d0c2b36.gif";